// ActionEvidenceTab — evidence attached to the current action.
// Thin wrapper around the shared EvidenceTab component.

import { useParams } from '@tanstack/react-router'
import { useApi } from '@/lib/api/client'
import { useTenant } from '@/components/shared/TenantShell'
import { actionsApi } from '@/lib/api/actions'
import { queryKeys } from '@/lib/api/queryKeys'
import { EvidenceTab } from '@/components/features/evidence'
import { useAuth } from 'react-oidc-context'

export function ActionEvidenceTab() {
  const { slug } = useTenant()
  const { actionId } = useParams({ strict: false }) as { actionId: string }
  const api = useApi()
  const auth = useAuth()
  const actApi = actionsApi(api)

  return (
    <EvidenceTab
      queryKey={queryKeys.actions.evidence(slug, actionId)}
      fetchFn={(includeArchived) => actApi.evidence(actionId, includeArchived)}
      uploadFn={(params) =>
        actApi.uploadEvidence(actionId, {
          file: params.file,
          evidenceTagId: params.evidenceTagId,
          comment: params.comment,
        })
      }
      downloadFn={(url) =>
        fetch(url, {
          headers: { Authorization: `Bearer ${auth.user?.id_token ?? ''}` },
        })
      }
      archiveFn={(evidenceId) => actApi.archiveEvidence(actionId, evidenceId)}
      entityNoun="action"
    />
  )
}
